<template>
  <div class="fts-list">
    <draggable v-model="formData[item.fieldName]" v-bind="dragOptions" handle=".handle">
      <div class="list-form list-content" v-for="(data, index) in formData[item.fieldName]" :key="data.id">
        <!-- header -->
        <div class="list-form-header" @click="toggle(data)" :class="{'expanded': !data.hide}">
          <!-- ctrl -->
          <div class="list-form-header-ctrl stopPropagation" v-if="!view">
            <!-- handle -->
            <font-awesome-icon class="handle" :icon="['fas', 'grip-vertical']" fixed-width />
            <template v-if="isRowControl">
              <!-- add -->
              <fts-btn text icon sm @click="add(index + 1)">
                <font-awesome-icon :icon="['fas', 'plus']" />
              </fts-btn>
              <!-- remove -->
              <fts-btn text icon sm @click="remove(data)">
                <font-awesome-icon :icon="['fas', 'trash']" />
              </fts-btn>
            </template>
          </div>
          <!-- title -->
          <div class="list-form-header-title">{{title(data, index)}}</div>
          <!-- toggle -->
          <div class="list-form-header-toggle">
            <font-awesome-icon :icon="['fas', 'chevron-down']" />
          </div>
        </div>
        <!-- form -->
        <fts-transition-expand>
          <fts-form 
            :vector-id="vectorId" 
            :form-data="data" 
            :form="getForm(index)" 
            :view="view" 
            :validator="columnValidator(index)" 
            class="fts-scrollbar" 
            v-if="!data.hide" 
          />
        </fts-transition-expand>
      </div>
    </draggable>
    <!-- add -->
    <div 
      class="list-form-action" 
      @click="add(formData[item.fieldName]? formData[item.fieldName].length : 0)" 
      v-if="!view && isRowControl"
    >
      <font-awesome-icon :icon="['fas', 'plus']" fixed-width /> New
    </div>
  </div>
</template>

<script>
import commons from "../commons/commons";
import draggable from "vuedraggable";

import FTSTransitionExpand from "./FTSTransitionExpand";
import FTSBtn from "./FTSBtn";

export default {
  components: {
    draggable,
    "fts-transition-expand": FTSTransitionExpand,
    "fts-btn": FTSBtn
  },
  props: {
    vectorId: [Number, String],
    item: Object,
    formData: Object,
    view: Boolean,
    validator: Object,
  },
  data: () => ({
    dragOptions: commons.dragOptions,
  }),
  methods: {
    toggle(data) {
      if (commons.elementStopPropagation()) return;

      if (data.hide)
        this.$delete(data, 'hide')
      else
        this.$set(data, 'hide', true)
    },
    add(index) {
      let newRow = {
        id: commons.newUUID()
      };

      this.item.fields.forEach(x => {
        if (x && x.fieldName.indexOf(".") === -1) {
          this.$set(newRow, x.fieldName, null);
        }
      });

      if (this.formData[this.item.fieldName] == null) {
        this.$set(this.formData, this.item.fieldName, []);
      }

      const formDesign = _.cloneDeep(this.item.design);

      if (!Array.isArray(this.item.designs)) {
        this.$set(this.item, "designs", [formDesign]);
      } else {
        this.item.designs.splice(index, 0, formDesign);
      }

      this.formData[this.item.fieldName].splice(index, 0, newRow);
    },
    remove(data) {
      let listData = this.formData[this.item.fieldName];
      const rowIndex = listData.indexOf(data)
      listData.splice(rowIndex, 1);

      if (Array.isArray(this.item.designs)) {
        this.item.designs.splice(rowIndex, 1);
      }
    },
    title(data, index) {
      if (this.item.displayField) {
        try {
          const field = this.item.fields.find(x => x.displayName === this.item.displayField)
          const value = data[field.fieldName]
          if (value)
            return value
          else
            throw 'error'
        } catch(err) {
          return this.item.displayField
        }
      } else {
        return `${this.item.displayName} (${index + 1})`
      }
    },
    columnValidator(index) {
      try {
        const validations =  Object.values(this.validator.$each.$iter)
        return validations[index]
      } catch(err) {}
    },
    getForm(index) {
      if (
        Array.isArray(this.formData[this.item.fieldName]) && 
        !Array.isArray(this.item.designs)
      ) {
        this.$set(this.item, "designs", []);
        this.formData[this.item.fieldName].forEach(() => {
          this.item.designs.push(_.cloneDeep(this.item.design));
        });
      }

      let design = _.cloneDeep(this.item.designs[index]);
      commons.expandWorkDesign(this.item.fields, design)
      return design;
    }
  },
  computed: {
    isRowControl() {
      return !Boolean(this.item.disabledAddRemoveItems);
    },
    form() {
      commons.expandWorkDesign(this.item.fields, this.item.design)
      return this.item.design
    }
  },
  beforeCreate: function () {
		this.$options.components.FtsForm = require('./FTSForm').default
  }
}
</script>

<style lang="scss" scoped>
.fts-list {
  .list-form {
    margin-bottom: 0.75rem;
    border: 1px solid var(--fts-border);
    .list-form-header {
      display: flex;
      align-items: center;
      padding-left: 1rem;
      padding-right: 1rem;
      & + .fts-form-container {
        padding-top: 1rem;
        padding-left: 1rem;
        padding-right: 1rem;
        border-top: 1px solid var(--fts-form-control-border);
      }
      &.expanded {
        .list-form-header-toggle {
          > svg {
            transform: rotate(-90deg);
          }
        }
      }
      .list-form-header-ctrl {
        display: flex;
        align-items: center;
        margin-right: 0.5rem;
        > svg {
          &.handle {
            margin-right: 0.25rem;
            color: var(--fts-default);
            font-size: 0.75rem;
            cursor: grab;
          }
        }
      }
      .list-form-header-title {
        flex: 1;
        padding-top: 0.75rem;
        padding-bottom: 0.75rem;
        font-weight: 500;
        font-size: 0.75rem;
        line-height: 1rem;
        cursor: pointer;
      }
      .list-form-header-toggle {
        color: var(--fts-default);
        cursor: pointer;
        > svg {
          transition: transform 0.3s;
          font-size: 0.75rem;
        }
      }
    }
  }
  .list-form-action {
    padding: 0.5rem 1rem;
    background-color: var(--fts-gray-100);
    color: var(--fts-default);
    font-size: 0.75rem;
    line-height: 1rem;
    &:hover {
      cursor: pointer;
      color: var(--fts-primary);
    }
  }
}
</style>